(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    // Cart guardian: automatically removes any add-on with a _linked_main_variant property
// when its linked main product is no longer in the cart.
(function () {
  let guardianRunning = false;

  async function enforceLinkedItems() {
    if (guardianRunning) return;
    // Fast DOM check — skip the fetch entirely if no linked rows are rendered
    if (!document.querySelector('[data-linked-main-variant]')) return;

    guardianRunning = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const cartVariantIds = new Set(cart.items.map(item => String(item.variant_id)));

      const orphanedKeys = cart.items
        .filter(item =>
          item.properties?._linked_main_variant &&
          !cartVariantIds.has(String(item.properties._linked_main_variant))
        )
        .map(item => item.key);

      if (orphanedKeys.length === 0) return;

      // Shimmer the price of each orphaned add-on row while the removal is in flight
      orphanedKeys.forEach(key => {
        const row = document.querySelector(`[data-key="${CSS.escape(key)}"]`);
        row?.querySelector('.cart-items__price text-component')?.shimmer?.();
      });

      await Promise.all(
        orphanedKeys.map(key =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          })
        )
      );

      // Trigger a cart UI refresh so the drawer re-renders without the orphaned add-on
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'sm-cart-guardian', data: { source: 'sm-cart-guardian' } },
      }));
    } catch (err) {
      console.error('[sm-cart-guardian]', err);
    } finally {
      guardianRunning = false;
    }
  }

  document.addEventListener('cart:update', (e) => {
    const source = e.detail?.data?.source;
    // Ignore our own events to avoid loops
    if (source === 'sm-cart-guardian' || source === 'sm-addon-picker') return;
    enforceLinkedItems();
  });
}());
  } catch(e) { console.error(e); }
})();

})();
